import styles from "./styles/style.module.scss";

const Input = ({
  disabled,
  label,
  type,
  placeholder,
  value,
  name,
  onChangeHandler,
  error,checked
}) => {

  return (
    <div className={styles.inputDiv}>
      <label className={styles.inputLabel}>{label}</label>
      <input
      checked={checked}
        style={{ borderColor: error ? "red" : "" }}
        type={type}
        placeholder={placeholder}
        value={value}
        name={name}
        onChange={onChangeHandler}
        disabled={disabled}
      />

      {error && (
        <span className={styles.errorState} > * Required</span>
      )}
    </div>
  );
};

export default Input;
